import i18n, { type ResourceLanguage } from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import type { RealLanguage } from './LanguageContext'

const localeLoaders: Partial<Record<RealLanguage, () => Promise<unknown>>> = {
  ar: () => import('./locales/ar.json').then((module) => module.default),
  es: () => import('./locales/es.json').then((module) => module.default),
  fr: () => import('./locales/fr.json').then((module) => module.default),
  zh: () => import('./locales/zh.json').then((module) => module.default),
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export async function changeAppLanguage(lang: RealLanguage): Promise<void> {
  if (!i18n.hasResourceBundle(lang, 'translation')) {
    const loader = localeLoaders[lang]
    if (loader) {
      const resource = await loader()
      i18n.addResourceBundle(
        lang,
        'translation',
        resource as ResourceLanguage,
        true,
        true,
      )
    }
  }
  await i18n.changeLanguage(lang)
}

export default i18n
